import { classNames } from "@frec-js/common-web";
import { FC } from "react";
import { PiClock } from "react-icons/pi";

import { PostType } from "../utils/blogApi";

export const BlogMetaReadingTime: FC<{
  post: PostType;
  className?: string;
}> = ({ post, className }) => {
  return post.readingMins ? (
    <div className={classNames("flex items-center gap-2", className)}>
      <PiClock size={20} className="inline" />
      {post.readingMins} min read
    </div>
  ) : null;
};
